import { render } from "./FooterSandbars.vue?vue&type=template&id=4f6c0fa6"
import script from "./FooterSandbars.vue?vue&type=script&lang=js"
export * from "./FooterSandbars.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__